import { AnimatePresence, motion } from 'framer-motion'
import React, { useState } from 'react'
import { useMeasure } from 'react-use'
import Slider from '../molecules/Slider'

const swipeConfidenceThreshold = 1000

const swipePower = (offset, velocity) => {
  return Math.abs(offset) * velocity
}

const variants = {
  enter: direction => {
    return {
      x: direction > 0 ? 32 : -32,
      y: direction > 0 ? 32 : -32,
      opacity: 0,
    }
  },
  center: {
    x: 0,
    y: 0,
    opacity: 1,
  },
  exit: direction => {
    return {
      x: direction < 0 ? 20 : -32,
      y: direction < 0 ? 20 : -32,
      opacity: 0,
      position: 'absolute',
    }
  },
}

const M09BoxRotator = ({ heading, body, boxes, anchorLinkId }) => {
  const [[page, direction], setPage] = useState([0, 0])
  let [ref, { height }] = useMeasure()

  const paginate = newDirection => {
    setPage([page + newDirection, newDirection])
  }

  return (
    <section className="pb-10 my-10 overflow-hidden md:my-20" id={anchorLinkId}>
      <div className="container">
        <div className="row-type-e-start">
          <div className="col-1-type-e">
            <h2 className="mb-5 u-h1">{heading}</h2>
            <div className="column-indent">
              <div
                className="u-p link-wrapper"
                dangerouslySetInnerHTML={{ __html: body }}
              />
            </div>
          </div>
          <div className="pt-8 col-2-type-e sm:pt-14">
            <Slider
              count={boxes.length}
              index={page}
              onChange={index => {
                if (page <= index) {
                  setPage([index, 1])
                } else {
                  setPage([index, -1])
                }
              }}
            />

            <motion.div
              animate={{ height: height || 'auto' }}
              transition={{ ease: 'easeOut', duration: 0.3 }}
              className="relative mr-10"
            >
              <div className="absolute inset-0 transform translate-x-8 translate-y-8 border-2 rounded-[5px] bg-red-as opacity-70 -z-1"></div>
              <div ref={ref}>
                <AnimatePresence initial={false} custom={direction}>
                  <motion.div
                    key={page}
                    drag="x"
                    dragConstraints={{ left: 0, right: 0 }}
                    custom={direction}
                    variants={variants}
                    initial="enter"
                    animate="center"
                    exit="exit"
                    dragElastic={0.1}
                    transition={{
                      x: { duration: 0.7 },
                      y: { duration: 0.7 },
                      opacity: { duration: 0.4 },
                    }}
                    onDragEnd={(e, { offset, velocity }) => {
                      const swipe = swipePower(offset.x, velocity.x)

                      if (swipe < -swipeConfidenceThreshold) {
                        if (page < boxes.length - 1) {
                          paginate(1)
                        }
                      } else if (swipe > swipeConfidenceThreshold) {
                        if (page > 0) {
                          paginate(-1)
                        }
                      }
                    }}
                    className="bg-red-as rounded-[5px] p-10 pl-6 text-white u-p flex justify-between items-start"
                  >
                    <div className="flex-shrink-0 text-center w-14 u-h0">
                      {page + 1}
                    </div>
                    <div>
                      <strong>{boxes[page].title}</strong> {boxes[page].body}
                    </div>
                  </motion.div>
                </AnimatePresence>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default M09BoxRotator
